import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Props-Schnittstelle
interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Wenn noch geladen wird, zeige Ladeanzeige
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Wenn nicht authentifiziert, weiterleiten
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Ansonsten die geschützten Inhalte anzeigen
  return <>{children}</>;
};

export default AuthGuard;
